<!-- Top bar -->
<mat-toolbar class="topBar" color="#005d87">

  <!-- Back to Home -->
  <button mat-icon-button
          class="example-icon"
          type="button"
          aria-label="Example icon-button with menu icon"
          matTooltip="Back to Home"
          matTooltipPosition="below"
          (click)="router.navigate(['menu'])">
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>

  <!-- Page title -->
  <span style="color: var(--elog-topbar-text);">
    My Profile
  </span>

</mat-toolbar>


<div class="container">

  <form [formGroup]="profileForm">
    <div class="row justify-content-center" style="padding-top: 25px;">

      <mat-form-field appearance="fill">
        <mat-label>Vessel Operator First Name</mat-label>
        <input matInput formControlName="firstName" required>
        <mat-error *ngIf="profileForm.get('firstName')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="profileForm.get('firstName')?.errors?.pattern">Invalid character</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field appearance="fill">
        <mat-label>Vessel Operator Last Name</mat-label>
        <input matInput formControlName="lastName" required>
        <mat-error *ngIf="profileForm.get('lastName')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="profileForm.get('lastName')?.errors?.pattern">Invalid character</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" required>
        <mat-icon matSuffix>mail</mat-icon>
        <mat-error *ngIf="profileForm.get('email')?.errors?.required">Required</mat-error>
        <mat-error *ngIf="profileForm.get('email')?.errors?.email">Invalid email</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field #telField appearance="fill">
        <mat-label>Phone Number</mat-label>
        <app-tel-input #telInput formControlName="phoneNum"></app-tel-input>
        <mat-icon matSuffix>phone</mat-icon>
        <mat-error *ngIf="!profileForm.get('phoneNum')?.value">Required</mat-error>
      </mat-form-field>
  
    </div>
  
    <div class="row justify-content-center">
  
      <mat-form-field appearance="fill">
        <mat-label>State Fisher License Number</mat-label>
        <input matInput formControlName="licenseNum">
        <mat-error *ngIf="profileForm.get('licenseNum')?.errors?.maxlength || profileForm.get('licenseNum')?.errors?.minlength">5 - 8 characters required</mat-error>
        <mat-error *ngIf="profileForm.get('licenseNum')?.errors?.pattern">Invalid character: Numbers and letters only</mat-error>
      </mat-form-field>
  
    </div>
  
  </form>

  <!-- ===================== Appearance / dark mode ===================== -->
  <section class="appearance-section" aria-labelledby="appearance-heading">

    <h2 id="appearance-heading" class="appearance-heading">Appearance</h2>
    <p class="appearance-hint">
      Saved per device. Choose a light or dark theme, or follow your device's system setting.
    </p>

    <!-- Light / Dark / Follow device -->
    <mat-button-toggle-group class="mode-group"
                             aria-label="Colour theme"
                             [value]="theme.mode()"
                             (change)="theme.setMode($event.value)">

      <mat-button-toggle value="light">
        <mat-icon>light_mode</mat-icon>
        Light
      </mat-button-toggle>

      <mat-button-toggle value="dark">
        <mat-icon>dark_mode</mat-icon>
        Dark
      </mat-button-toggle>

      <mat-button-toggle value="system">
        <mat-icon>brightness_auto</mat-icon>
        Device
      </mat-button-toggle>

    </mat-button-toggle-group>

    <!-- Dark palette picker -->
    <h3 class="variant-heading">Dark theme style</h3>
    <p class="appearance-hint">
      Tap one to preview it. Choosing a style switches the app to dark mode.
    </p>

    <div class="variant-list" role="radiogroup" aria-label="Dark theme style">

      @for (variant of theme.variants; track variant.id) {

        <button type="button"
                class="variant-card"
                role="radio"
                [class.variant-card--active]="theme.darkVariant() === variant.id"
                [attr.aria-checked]="theme.darkVariant() === variant.id"
                (click)="previewVariant(variant.id)">

          <!-- Miniature of the app in that palette -->
          <span class="variant-preview"
                [style.background]="variant.swatch[0]"
                aria-hidden="true">
            <span class="variant-preview__bar" [style.background]="variant.swatch[2]"></span>
            <span class="variant-preview__card" [style.background]="variant.swatch[1]"></span>
            <span class="variant-preview__card variant-preview__card--short"
                  [style.background]="variant.swatch[1]"></span>
          </span>

          <span class="variant-text">
            <span class="variant-name">
              {{ variant.name }}
              @if (theme.darkVariant() === variant.id) {
                <mat-icon class="variant-check">check_circle</mat-icon>
              }
            </span>
            <span class="variant-blurb">{{ variant.blurb }}</span>
          </span>

        </button>

      }

    </div>

  </section>

</div>
